/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import pearlApi from '../sharedcomponents/api/pearlApi';
import { CommentType } from './commentsSlice';

/** Fetch comments for a page */
export async function fetchPageComments(pageId: string): Promise<{ pageId: string; comments: CommentType[] }> {
  try {
    const data: CommentType[] = (await pearlApi.get(`/pages/${pageId}/comments`)).data.data?.comments || [];
    return { pageId, comments: data };
  } catch (error) {
    // Don't worry about 404s, just means there are no comments
    if ((error as any).response?.status === 404) {
      return { pageId, comments: [] };
    }
    throw error;
  }
}

/** Add a comment to the current page */
export async function createComment(
  pageId: string,
  content: string,
  additionalData?: { needs_attention?: boolean; from_ai?: boolean }
) {
  await pearlApi.post<
    any,
    void,
    { data: Omit<CommentType, 'pageId' | 'id' | 'createdAt' | 'state' | 'user' | 'documentVersion'> }
  >(`/pages/${pageId}/comments`, {
    data: { content, ...additionalData },
  });
}

export async function changeCommentState(
  commentId: string,
  newState: { state: 'OPEN' | 'RESOLVED'; documentVersionId: string; from_ai?: boolean; needs_attention?: boolean }
) {
  await pearlApi.put(`/comments/${commentId}`, { data: newState });
}

export async function deleteComment(commentId: string, documentVersionId: string) {
  await pearlApi.delete(`/comments/${commentId}`, { data: { data: { documentVersionId } } });
}
